import { GlutenFreeIcons, GlutenFreeIconsList } from "@/constants/gluten-free";

const generateGreenFilledIcon = (count) => {
	return `
        <svg width="60" height="30" viewBox="0 0 89 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.157 42.25v1.219h64.844c11.442 0 20.718-9.276 20.718-20.719S78.444 2.031 67.002 2.031H21.559c-10.715 0-19.402 8.687-19.402 19.403z" fill="#18C1AE"/>
          <path d="M2.157 42.25v1.219h64.844c11.442 0 20.718-9.276 20.718-20.719S78.444 2.031 67.002 2.031H21.559c-10.715 0-19.402 8.687-19.402 19.403z" stroke="#18C1AE" stroke-width="2.438"/>
          <text
                x="45"
                y="28"
                font-size="19"
                fill="white"
                stroke="white"
                stroke-width="0.5"
                font-weight="600"
                style="font-family: 'Inter', sans-serif; letter-spacing: 0.24px;"
                text-anchor="middle">
            ${count}
        </text>
        </svg>
    `;
};
const generateGFGreenOutlinedIcon = (count) => {
	return `
        <svg width="60" height="30" viewBox="0 0 60 30"  fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.1875 28V28.8125H2H44.4167C52.0451 28.8125 58.2292 22.6284 58.2292 15C58.2292 7.37157 52.0451 1.1875 44.4167 1.1875H14.1224C6.97865 1.1875 1.1875 6.97865 1.1875 14.1224V28Z" fill="#E4FCF9"/>
        <path d="M1.1875 28V28.8125H2H44.4167C52.0451 28.8125 58.2292 22.6284 58.2292 15C58.2292 7.37157 52.0451 1.1875 44.4167 1.1875H14.1224C6.97865 1.1875 1.1875 6.97865 1.1875 14.1224V28Z" stroke="#18C1AE" stroke-width="1.625"/>
        <text
                x="29"
                y="19"
                font-size="12"
                stroke-width="0.5"
                stroke="#002551"
                fill="#002551"
                style="font-family: 'Inter', sans-serif; font-weight: 200; letter-spacing: 0.24px;"
                text-anchor="middle">
            ${count}
        </text>
    </svg>
    `;
};

const generateGreenDashedIcon = (count) => {
	return `
        <svg width="60" height="30" viewBox="0 0 60 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          stroke="#18C1AE" stroke-width="2" stroke-dasharray="4,5"
          d="M1.1875 28V28.8125H2H44.4167C52.0451 28.8125 58.2292 22.6284 58.2292 15C58.2292 7.37157 52.0451 1.1875 44.4167 1.1875H14.1224C6.97865 1.1875 1.1875 6.97865 1.1875 14.1224V28Z" fill="#E4FCF9"/>
            <text
                x="28"
                y="19"
                stroke-width="0.5"
                stroke="#002551"
                fill="#002551"
                style="font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 200; letter-spacing: 0.24px;"
                text-anchor="middle">
            ${count}
        </text>
        </svg>
    `;
};

const generateUnknownIcon = (count) => {
	return `
        <svg width="52" height="30" viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.1875 28V28.8125H2H36.4167C44.0451 28.8125 50.2292 22.6284 50.2292 15C50.2292 7.37157 44.0451 1.1875 36.4167 1.1875H16.4884C8.03796 1.1875 1.1875 8.03796 1.1875 16.4884V28Z" fill="white"/>
            <path d="M1.1875 28V28.8125H2H36.4167C44.0451 28.8125 50.2292 22.6284 50.2292 15C50.2292 7.37157 44.0451 1.1875 36.4167 1.1875H16.4884C8.03796 1.1875 1.1875 8.03796 1.1875 16.4884V28Z" stroke="#DCE2E9" stroke-width="1.625"/>
            <path d="M9.71875 15C9.71875 12.0832 12.0832 9.71875 15 9.71875C17.9168 9.71875 20.2812 12.0832 20.2812 15C20.2812 17.9168 17.9168 20.2812 15 20.2812H9.71875V15Z" stroke="white"/>
              <text
                    x="26"
                    y="19"
                    fill="#002551"
                    stroke="#002551"
                    stroke-width="0.5"
                    style="font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 300; letter-spacing: 0.24px;"
                    text-anchor="middle">
                ${count}
                </text>
        </svg>
    `;
};

const generateSelectedIcon = (count) => {
	return `
        <svg width="50" height="30" viewBox="0 0 50 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 27V28.5H3H35C42.4558 28.5 48.5 22.4558 48.5 15C48.5 7.54416 42.4558 1.5 35 1.5H16.4444C8.19086 1.5 1.5 8.19086 1.5 16.4444V27Z" fill="#002551"/>
            <path d="M1.5 27V28.5H3H35C42.4558 28.5 48.5 22.4558 48.5 15C48.5 7.54416 42.4558 1.5 35 1.5H16.4444C8.19086 1.5 1.5 8.19086 1.5 16.4444V27Z" stroke="#002551" stroke-width="3"/>
            <path d="M10.125 15C10.125 12.3076 12.3076 10.125 15 10.125C17.6924 10.125 19.875 12.3076 19.875 15C19.875 17.6924 17.6924 19.875 15 19.875H10.125V15Z" stroke="#002551"/>
            <text
                x="25"
                y="19"
                fill="white"
                stroke="white"
                stroke-width="0.5"
                style="font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 300; letter-spacing: 0.24px;"
                text-anchor="middle">
                ${count}
            </text>
        </svg>
    `;
};

const getIconUrl = (svgString) =>
	`data:image/svg+xml;base64,${btoa(svgString)}`;

export const getMarkers = () => {
	function formatNumber(num) {
		if (num >= 1000) {
			return (num / 1000).toFixed(1) + "K";
		}
		return num.toString();
	}

	return GlutenFreeIconsList.map((icon) => ({
		key: icon,
		getSrc: (type, count) => {
			// const formattedNumber = formatNumber(count);
			const formattedNumber = `# ${count}`;

			switch (type) {
				case GlutenFreeIcons.SELECTED:
					return getIconUrl(generateSelectedIcon(formattedNumber));

				case GlutenFreeIcons.GREEN_FILLED:
					return getIconUrl(generateGreenFilledIcon(formattedNumber));

				case GlutenFreeIcons.GREEN_OUTLINED:
					return getIconUrl(generateGFGreenOutlinedIcon(formattedNumber));

				case GlutenFreeIcons.GREEN_DOTTED:
					return getIconUrl(generateGreenDashedIcon(formattedNumber));

				case GlutenFreeIcons.UNKNOWN:
				default:
					return getIconUrl(generateUnknownIcon(formattedNumber));
			}
		},
	}));
};
